import React, { Component } from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import Redoc from "./components/Redoc";
import Markdown from "./components/Markdown";
import Home from "./components/Home";
import Menu from "./components/Menu";
import ScrollToTop from "./components/ScrollToTop";

class App extends Component {
  render() {
    return (
      <Router>
        <ScrollToTop>
          <Menu />
          <div className="App">
            <Switch>
              <Route path="/about/:mode/:docname" component={Markdown} />
              <Route path="/api/:apiname" component={Redoc} />
              <Route path="/" component={Home} />
              <Redirect to="/" />
            </Switch>
          </div>
        </ScrollToTop>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js